exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._28P20ZWRBU_zpKhGhnvoqf{top:48px;bottom:0;position:fixed;z-index:2}html[dir] ._28P20ZWRBU_zpKhGhnvoqf{background:\"[theme:white, default:#ffffff]\"}html[dir=ltr] ._28P20ZWRBU_zpKhGhnvoqf,html[dir=rtl] ._28P20ZWRBU_zpKhGhnvoqf{left:0;right:0}", ""]);

// exports
exports.locals = {
	"SxSView": "_28P20ZWRBU_zpKhGhnvoqf"
};